/**
 * Trigger: tr_incomes_soft_delete_external
 * Purpose: When an income is soft-deleted, detach its related external marker links
 * Table: incomes
 * Event: UPDATE OF is_deleted
 */
export const TR_INCOMES_SOFT_DELETE_EXTERNAL = `
CREATE TRIGGER tr_incomes_soft_delete_external
UPDATE OF is_deleted ON incomes
WHEN new.is_deleted <> 0 AND old.is_deleted = 0
BEGIN
  UPDATE external_transactions
  SET income_id = NULL
  WHERE income_id = old._id AND is_deleted = 0;
END;
`;
